import UrlPattern from 'url-pattern';

const construct = url => new UrlPattern('(*)' + url);

export const VACANCIES = construct('/vacancies.json');
export const VACANCY = construct('/vacancies/:id.json');
export const FACETS = construct('/vacancy/facets');
